import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { CommonSharedModule } from '../common/common-shared.module';
import { ClientAdditionalInfoRequestListComponent } from './client-additional-info-request-list/client-additional-info-request-list.component';
import { DashboardChecklistComponent } from './dashboard-checklist/dashboard-checklist.component';
import { HeaderComponent } from './header/header.component';
import { MultiAnswerButtonListComponent } from './multi-answer-button-list/multi-answer-button-list.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ShellComponent } from './shell/shell.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { StatefulAnswerButtonListComponent } from './stateful-answer-button-list/stateful-answer-button-list.component';
import { StatefulInternalLinkComponent } from './stateful-internal-link/stateful-internal-link.component';
import { StatefulPrimaryButtonComponent } from './stateful-primary-button/stateful-primary-button.component';
import { StatefulSecondaryButtonComponent } from './stateful-secondary-button/stateful-secondary-button.component';

const components = [
  DashboardChecklistComponent,
  HeaderComponent,
  ShellComponent,
  SidenavComponent,
  StatefulInternalLinkComponent,
  StatefulPrimaryButtonComponent,
  StatefulSecondaryButtonComponent,
  ProgressBarComponent,
  StatefulAnswerButtonListComponent,
  MultiAnswerButtonListComponent,
  ClientAdditionalInfoRequestListComponent,
];

const modules = [CommonModule, CommonSharedModule, LoaderModule, TooltipModule];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class OnboardingSharedModule {}
